import React from 'react';

const ServiceTypeSection = ({ 
  formData,
  handleChange,
  availableServiceTypes,
  job
}) => {
  return (
    <div>
      <label htmlFor="serviceType" className="block text-sm font-medium text-gray-700">
        Service Type
        {formData.hasServiceTypeOverride && (
          <span className="text-sky-600 ml-2">(Manual Override)</span>
        )}
      </label>
      <select
        id="serviceType"
        name="serviceTypeId"
        value={formData.serviceTypeId}
        onChange={handleChange}
        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-600 p-2 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm rounded-md"
      >
        <option value="">Select Service Type</option>
        {availableServiceTypes.map(serviceType => (
          <option key={serviceType.id} value={serviceType.id}>
            {serviceType.title} ({serviceType.category})
          </option>
        ))}
      </select>
      
      {job.serviceType && formData.serviceTypeId !== job.serviceType.id && (
        <div className="mt-2 p-3 bg-amber-50 border border-amber-200 rounded-md">
          <div className="text-sm text-amber-800">
            <span className="font-medium">Service type change:</span> {job.serviceType.title} → {availableServiceTypes.find(st => st.id === formData.serviceTypeId)?.title || 'Unknown'}
          </div>
          <div className="text-xs text-amber-700 mt-1">
            This change will be protected from automatic Streamline sync updates.
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceTypeSection;